// dashboard.selectors.ts

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DashboardState, dashboardFeatureKey } from "./dashboard.reducer";

export const selectDashboardState =
  createFeatureSelector<DashboardState>(dashboardFeatureKey);

export const selectDashboardData = createSelector(
  selectDashboardState,
  (state) => state.dashboardData
);

export const selectDashboardLoading = createSelector(
  selectDashboardState,
  (state) => state.loading
);
export const selectAllocatedProjects = createSelector(
  selectDashboardState,
  (state) => state.allocatedProjects
);
export const selectAllocatedLoading = createSelector(
  selectDashboardState,
  (state) => state.loading
);

export const selectSelectedProject = createSelector(
  selectDashboardState,
  (state) => state.selectedProject
);
